module.exports = __webpack_public_path__ + "static/img/gongyiguocheng.0836f0e2.png";